import { render, staticRenderFns } from "./LoginJWT.vue?vue&type=template&id=2ca76990"
import script from "./LoginJWT.vue?vue&type=script&lang=js"
export * from "./LoginJWT.vue?vue&type=script&lang=js"
import style0 from "./LoginJWT.vue?vue&type=style&index=0&id=2ca76990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports